import enUS from './locales/en-US.json';
import esLA from './locales/es-LA.json';
import esES from './locales/es-ES.json';
import frCA from './locales/fr-CA.json';
import frFR from './locales/fr-FR.json';
import ptBR from './locales/pt-BR.json';
import ar from './locales/ar.json';
import deDE from './locales/de-DE.json';
import hiIN from './locales/hi-IN.json';
import idID from './locales/id-ID.json';
import itIT from './locales/it-IT.json';
import jaJP from './locales/ja-JP.json';
import nlNL from './locales/nl-NL.json';
import plPL from './locales/pl-PL.json';
import koKR from './locales/ko-KR.json';
import ruRU from './locales/ru-RU.json';
import svSE from './locales/sv-SE.json';
import thTH from './locales/th-TH.json';
import trTR from './locales/tr-TR.json';
import viVN from './locales/vi-VN.json';
import zhTW from './locales/zh-TW.json';
import { LineOfBusinesses, } from '../../constants/LineOfBusiness';
const addNamespace = (translation) => ({ translation });
export const translations = {
    'en-US': addNamespace(enUS),
    'es-LA': addNamespace(esLA),
    'es-ES': addNamespace(esES),
    'fr-CA': addNamespace(frCA),
    'fr-FR': addNamespace(frFR),
    'pt-BR': addNamespace(ptBR),
    ar: addNamespace(ar),
    'de-DE': addNamespace(deDE),
    'hi-IN': addNamespace(hiIN),
    'id-ID': addNamespace(idID),
    'it-IT': addNamespace(itIT),
    'ja-JP': addNamespace(jaJP),
    'ko-KR': addNamespace(koKR),
    'nl-NL': addNamespace(nlNL),
    'pl-PL': addNamespace(plPL),
    'ru-RU': addNamespace(ruRU),
    'sv-SE': addNamespace(svSE),
    'th-TH': addNamespace(thTH),
    'tr-TR': addNamespace(trTR),
    'vi-VN': addNamespace(viVN),
    'zh-TW': addNamespace(zhTW),
};
export const SupportedLanguageCodes = Object.keys(translations);
export const getLineOfBusinessName = (lineOfBusiness) => {
    switch (lineOfBusiness) {
        case LineOfBusinesses.S4P_STAGING:
        case LineOfBusinesses.S4P: {
            return 'Spotify for Podcasters';
        }
        case LineOfBusinesses.S4A_STAGING:
        case LineOfBusinesses.S4A: {
            return 'Spotify for Artists';
        }
        case LineOfBusinesses.CONSUMER_STAGING:
        case LineOfBusinesses.CONSUMER: {
            return 'Spotify';
        }
        default: {
            return 'Unknown Line Of Business';
        }
    }
};
//# sourceMappingURL=index.js.map